import { Injectable } from '@angular/core';
import { Service } from './services';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AlertasComponent } from './alertas/alertas.component';
import { LoadingScreenService } from './services/loading-screen/loading-screen.service';
import { fromEvent, Observable, Subject } from "rxjs";
import { Subscription } from "rxjs";
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PopTermsComponent } from './components/pop-terms/pop-terms.component';
import { MessageService } from './message.service';
@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public code;
  public region;
  public origin = "11";
  public contentSplash:any='';
  public optionTemplete:any='';
  public splashActive:boolean=false;
  public idNotic:number=0;
  isIframe  = false
  public infoStreaming = {
    data: {
      idDevice: 103,
      nameDevie: "Router",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias vero dolorem officiis, officia excepturi, fugit nulla doloremque fuga cumque nam a cum illum repellendus aspernatur ipsam unde ratione natus delectus",
      urlImg: "assets/images/imagen_Equipo.png",
      numberAccessories: 1,
      maxNumAccessories: 10,
      paymentMethods:
        [
          {
            check: true,
            name: "COMPRAR A PLAZOS",
            months: [
              {
                price: 8.33,
                num: 12,
                check: true
              },
              {
                price: 5.33,
                num: 24,
                check: false
              }
            ],
          },
          {
            check: false,
            name: "PRECIO REGULAR",
            price: 99.99,
            months: null
          }
        ],
      checkTerms: false
    },
    payToday: 0,
    rent: 0,
  };
  public screenEnabled:boolean=true;
  public resizeObservable: Observable<Event>;
  public accountEmail:string='';
  public accountCity:string='';
  public accountSubscriber:string='';
  public banField:number=0;
  public accountAddress:string='';
  public accountState:string='';
  public accountZip:string='';
  public totalAmount:number=0;
  public tokenShop:string="";
  public deviceType: string = "device";
  public buyType: string = "full";
  public rotationTimeSva: number = 30000;
  public maximumString: number = 60;
  public token = sessionStorage.getItem("token");
  public creditClass: string = 'C';
  public cartItems: any = [];
  public maxNumAccessories: number = 10;
  public myPlans2 = [
    {
      idPlan: "1",
      name: "Plan Esencial",
      price: 85,
      type: "Basico",
      description: "Acceso a 239 canales DIRECTV GO sin costo adicional Lleva hasta 3 meses gratis",
      channelsText: "113 Canales + 16 Premium",
      numberChannels: 113,
      numberPremiumChannels: 16,
      check: false
    },
    {
      idPlan: "2",
      name: "Plan Esencial Español",
      price: 100.00,
      type: "Avanzado",
      description: "Acceso a 204 canales DIRECTV GO sin costo adicional Lleva hasta 3 meses gratis",
      channelsText: "120 Canales + 26 Premium",
      numberChannels: 120,
      numberPremiumChannels: 26,
      check: false
    },
    {
      idPlan: "3",
      name: "Ultra Esencial",
      price: 120.00,
      type: "Superior",
      description: "DIRECTV GO sin costo adicional DIRECTV OnDEMAND HD + canal 4.000 en resolución 4k",
      channelsText: "140 Canales + 36 Premium",
      numberChannels: 140,
      numberPremiumChannels: 36,
      check: false
    },
    {
      idPlan: "4",
      name: "DIRECTV GO",
      price: 180.00,
      type: "Familiar",
      description: "Acceso a más de 90 canales en vivo Deporte en vivo + 3000 títulos para ver on demand",
      channelsText: "153 Canales + 56 Premium",
      numberChannels: 153,
      numberPremiumChannels: 56,
      check: false
    },
    {
      idPlan: "5",
      name: "Prepago HD",
      price: 200.00,
      type: "Premium",
      description: "167 CANALES: 81 SD, 50 HD Y 36 AUD Sin facturas fijas mensuales DIRECTV GO sin costo adicional",
      channelsText: "200 Canales + 100 Premium",
      numberChannels: 200,
      numberPremiumChannels: 100,
      check: false
    },
    {
      idPlan: "6",
      name: "Premium Black",
      price: 200.00,
      description: "1000 CANALES: 200 SD, 150 HD Y 36 AUD Sin facturas fijas mensuales DIRECTV GO sin costo adicional, acceso a todo el contenido exclusivo.",
      type: "Super Premium",
      channelsText: "200 Canales + 100 Premium",
      numberChannels: 1000,
      numberPremiumChannels: 400,
      check: false
    }
  ];
  public myPlans = [
    [
      {
        idPlan: "1",
        name: "Plan Esencial",
        price: 85,
        type: "Basico",
        description: "Acceso a 239 canales DIRECTV GO sin costo adicional Lleva hasta 3 meses gratis",
        channelsText: "113 Canales + 16 Premium",
        numberChannels: 113,
        numberPremiumChannels: 16,
        check: false
      },
      {
        idPlan: "2",
        name: "Plan Esencial Español",
        price: 100.00,
        type: "Avanzado",
        description: "Acceso a 204 canales DIRECTV GO sin costo adicional Lleva hasta 3 meses gratis",
        channelsText: "120 Canales + 26 Premium",
        numberChannels: 120,
        numberPremiumChannels: 26,
        check: false
      },
      {
        idPlan: "3",
        name: "Ultra Esencial",
        price: 120.00,
        type: "Superior",
        description: "DIRECTV GO sin costo adicional DIRECTV OnDEMAND HD + canal 4.000 en resolución 4k",
        channelsText: "140 Canales + 36 Premium",
        numberChannels: 140,
        numberPremiumChannels: 36,
        check: false
      },
    ],
    [
      {
        idPlan: "4",
        name: "DIRECTV GO",
        price: 180.00,
        type: "Familiar",
        description: "Acceso a más de 90 canales en vivo Deporte en vivo + 3000 títulos para ver on demand",
        channelsText: "153 Canales + 56 Premium",
        numberChannels: 153,
        numberPremiumChannels: 56,
        check: false
      },
      {
        idPlan: "5",
        name: "Prepago HD",
        price: 200.00,
        type: "Premium",
        description: "167 CANALES: 81 SD, 50 HD Y 36 AUD Sin facturas fijas mensuales DIRECTV GO sin costo adicional",
        channelsText: "200 Canales + 100 Premium",
        numberChannels: 200,
        numberPremiumChannels: 100,
        check: false
      },
      {
        idPlan: "6",
        name: "Premium Black",
        price: 200.00,
        description: "1000 CANALES: 200 SD, 150 HD Y 36 AUD Sin facturas fijas mensuales DIRECTV GO sin costo adicional, acceso a todo el contenido exclusivo.",
        type: "Super Premium",
        channelsText: "200 Canales + 100 Premium",
        numberChannels: 1000,
        numberPremiumChannels: 400,
        check: false
      }
    ]
  ];
  public chanelList = [
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/abc.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/big.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/bravo.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/cn.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/cnn.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/cozi.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/disney.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/disneyxd.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/espn.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/ff.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/foxnews.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/golf.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/HLN.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/nba.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/telemundo.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/TNT.png"
    },
    {
      plan: "Adultos",
      category: "Peliculas",
      url: "/assets/images/playboy.png"
    },
    {
      plan: "Adultos",
      category: "Deportes",
      url: "/assets/images/realitykings.png"
    },
    {
      plan: "Premium",
      category: "Peliculas",
      url: "/assets/images/cinemax.png"
    },
    {
      plan: "Premium",
      category: "Peliculas",
      url: "/assets/images/hbo.png"
    },
    {
      plan: "Premium",
      category: "Peliculas",
      url: "/assets/images/hbocinemax.png"
    },
    {
      plan: "Premium",
      category: "Peliculas",
      url: "/assets/images/starzencore.png"
    },
  ];
  public premiumChannels = [
    {
      idChannel: "1",
      name: "HBO® PACK",
      price: 4.5,
      description: "Las series originales más premiadas Contenido online en DIRECTV GO Recibe 1 mes gratis + 2 meses a 50%",
      check: false
    },
    {
      idChannel: "2",
      name: "STAR Premium",
      price: 10,
      description: "Las películas más nuevas Contenido online en DIRECTV GO Recibe 1 mes gratis + 2° mes al 50%",
      check: false
    },
    {
      idChannel: "3",
      name: "NFL Sunday Ticket",
      price: 5.5,
      description: "Hasta 12 partidos cada domingo Más de 150 juegos Con las estrellas de NFL",
      check: false
    },
    {
      idChannel: "4",
      name: "NBA League Pass™",
      price: 8.5,
      description: "Amplia variedad de partidos Cobertura online de los juegos Incluye Playoffs y finales",
      check: false
    },
    {
      idChannel: "5",
      name: "MLB Extra Innings™",
      price: 7.5,
      description: "Hasta 3590 partidos de la temporada Hasta 5 partidos por día Los mejores equipos de las grandes",
      check: false
    },
    {
      idChannel: "6",
      name: "EXXXÓTICO",
      price: 9.5,
      description: "Los mejores especiales y películas Amplia variedad de películas Acceso online a XTSYNow, sin costo",
      check: false
    },
    {
      idChannel: "7",
      name: "HOTPACK +",
      price: 10.5,
      description: "El mejor cine erótico Contenido online en HOTGO.TV Recibe 1 mes gratis + 2 meses a 50%",
      check: false
    },
    {
      idChannel: "8",
      name: "PLAYBOY TV",
      price: 20,
      description: "El mejor cine erótico Líder en entretenimiento 18+",
      check: false
    }
  ];

  public channelListLanding = [
    [
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/abc.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/america.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/clarocinema.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/HSN.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/megatv.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/telemundo.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/Wapa.png"
      }
    ],
    [
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/beinsports.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/clan.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/cnn-español.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/Discovery-Kids.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/foxsports.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/teleuniverso.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/tve.png"
      }
    ],
    [
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/abc.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/CBS.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/fox.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/NBC.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/Tele11.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/telemundo.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/Unimas.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/Wapa.png"
      }
    ],
    [
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/abc.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/america.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/clarocinema.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/HSN.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/megatv.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/telemundo.png"
      },
      {
        plan: "essential",
        category: "Peliculas",
        url: "/assets/images/Wapa.png"
      }
    ],
    [
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/beinsports.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/clan.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/cnn-español.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/Discovery-Kids.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/foxsports.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/teleuniverso.png"
      },
      {
        plan: "essential spanish",
        category: "Peliculas",
        url: "/assets/images/tve.png"
      }
    ],
    [
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/abc.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/CBS.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/fox.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/NBC.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/Tele11.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/telemundo.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/Unimas.png"
      },
      {
        plan: "ultra essential",
        category: "Peliculas",
        url: "/assets/images/Wapa.png"
      }
    ]
  ];

  public chanelListPopUp = [
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/america-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/beinsports-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/clan-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/cnnespanol-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/discoverykids-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/foxsports-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/hitn-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/HSN-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/nbc-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/telemundo-pop-up.png"
    },
    {
      plan: "Basico",
      category: "Peliculas",
      url: "/assets/images/tve-pop-up.png"
    }
  ];
  public urlExtenal: string="";
  public siteKey: string = '6Ld0s-MUAAAAAGOVXWz_pVrTNqcAMMCXOVLT4a5x';//6LcUfyMaAAAAANY-kejPUbEYvJC2zQHnThcEY6jP
  public finalize: boolean = false;
  public requiredPasswordReset: boolean = false;
  private sessionCounter: number = 1;
  private minutes: number = 15; //10
  private timeout: number = 60000; //60000
  private checker: boolean = false;
  public info = [];
  public referredData = [];
  public usage2 = [];
  public mixed = false;
  public showUserMobile = false;
  public referredSubscriber;
  public referredAccount;
  public pathChat: string = 'https://chat3.claropr.com/webapiserver/ECSApp/ChatWidget3/ChatPanel.aspx';
  public cancelPayment;
  public urlPayment;
  public urlChat;
  public activeNavigation: boolean;
  public buyBlock: boolean=false;
  public totalBalance: number=0;
  //---getConfig--------------------------
  public bundleId: number = 0;
  public packBundleId: any = [];
  public ban: string = '';
  public domain: string = 'http://shopqa.com';
  public externalMiClaro: string = "http://miclaroiptv.com/";
  public rotationTimeBanner: number = 30000;
  public rotationTimePlans: number = 30000;
  public catalogueIdIptv: number = 0;
  public maxNumEquipment: number = 0;
  public maxNumIptv: number = 0;
  public catalogueIdEquipment: number = 0;
  public catalogueIdAccessories: number = 0;
  public catalogueAccessory: number = 0;
  public streamingDeviceId: number = 0;
  //--------------------------------------
  initialize = new Subject();
  updateSplash = new Subject();
  loadObserver = new Subject();
  loadObserver2 = new Subject();
  paymentReceived = new Subject();
  achDataReceived = new Subject();
  giftReceived = new Subject();
  returnHome = new Subject();
  updatePaymentView = new Subject();
  rechargeReceived = new Subject();
  chatStatus = new Subject(); // suscripcion para abrir el chat
  uptypeAccount = new Subject(); //suscripcion al tipo de cuenta
  loadingPayment: Subscription;
  prepaidDataForEvaluate = {
    token: '',
    subscriber: '',
    socId: 0
  };
  ssoToken = '';
  public tokenShopUrl: any = '';

  constructor(private route: ActivatedRoute, private router: Router, public loadingScreenComponent: LoadingScreenComponent, public dialog: MatDialog, public services: Service, private loadingScreenService: LoadingScreenService, private messageService: MessageService) {
    this.resizeObservable = fromEvent(window, 'resize');
    this.services.getConfig().subscribe((data: any) => {
      this.bundleId = data.bundleId;
      this.packBundleId = data.packBundleId;
      this.ban = data.ban;
      this.domain = data.domain;
      // this.linkTwitter = data.linkTwitter;
      // this.linkFacebook = data.linkFacebook;
      this.rotationTimeBanner = data.rotationTimeBanner;
      this.maxNumAccessories = data.maxNumAccessories;
      this.catalogueIdIptv = data.catalogueIdIptv;
      this.maxNumEquipment = data.maxNumEquipment;
      this.maxNumIptv = data.maxNumIptv;
      this.catalogueIdEquipment = data.catalogueIdEquipment;
      this.catalogueIdAccessories = data.catalogueIdAccessories;
      this.catalogueAccessory = data.catalogueAccessory;
      //this.timeout = data.timeout;
      //todo: en prod existe
      this.streamingDeviceId = data.streamingDeviceId;
      this.packBundleId[0] = data.packBundleId[0];
      this.packBundleId[1] = data.packBundleId[1];
      this.urlExtenal = data.urlExtenal;
    });
  }
  errorHandling(e:any){
    this.notif("Estimado cliente, ha ocurrido un error por favor intentelo mas tarde.");
    this.loadingScreenService.stopLoading();
  }
  showSplahs(type:any){
    let messagesList:any=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).Messages.MessagesList;
    this.splashActive=false;
    for(let i=0;i<messagesList.length;i++){
      if(messagesList[i].alert_type==2 && messagesList[i].status==0){
        this.splashActive=true;
        this.contentSplash=messagesList[i].message;
        this.idNotic=messagesList[i].id_message;
        break
      }
    }
    if(sessionStorage.getItem("splashActive")==null){
      if(sessionStorage.getItem("splashActive")!="true"){
        sessionStorage.setItem("splashActive","true");
        if(type=='fixed'){
          this.splashActive=true;
          this.optionTemplete='splash';
        }
        else{
          this.optionTemplete='templete';
        }

        this.updateSplash.next(true);
      }
    }
  }
  irChat() {
    this.chatStatus.next(true);
  }
  isMobile() {
    return (
      (navigator.userAgent.match(/Android/i)) ||
      (navigator.userAgent.match(/webOS/i)) ||
      (navigator.userAgent.match(/iPhone/i)) ||
      (navigator.userAgent.match(/iPod/i)) ||
      (navigator.userAgent.match(/iPad/i)) ||
      (navigator.userAgent.match(/BlackBerry/i))
    );
  }
  securityFilter(value) {
    let patron = / AND /gi;
    value = value.toString().replace(patron, ' ');
    patron = / OR /gi;
    value = value.toString().replace(patron, ' ')

    patron = /  AND  /gi;
    value = value.toString().replace(patron, ' ')

    patron = /  OR  /gi;

    value = value.toString().replace(patron, ' ')
    return value;
  }
  updateTypeAccount(value) {
    this.uptypeAccount.next(value);
  }

  voidPayment(paymentToken, session = '') {
    this.loadingScreenService.startLoading(true, 'Su pago esta siendo regresado a la cuenta emisora, por favor espere...', true, session)
    this.services.voidPayment(paymentToken).subscribe(result => {
      this.loadingScreenService.stopLoading();
      if(!result.hasError) {
        console.log('voidPayment funciono!')
      }
    })
  }

  balancePendient(path:string=''){
    this.loadingScreenService.stopLoading();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {message:'<div>Estimado usuario, encontramos un saldo pendiente por : $'+ this.totalBalance +' para poder continuar con la compra debe realizar el pago.</div>',messageHtml:true};
    const dialogRef =this.dialog.open(AlertasComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if(value=='continue'){
        if(path!=''){
          this.router.navigate([path]);
        }
      }
    });
  }
  routerReturn(path) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: '¿Actualmente se encuentra en el proceso de compra de Clarotv+, si abandona se perderan los cambios realizados.', btmConfirm: true,labelSi:'Abandonar',labelNo:'Continuar' };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value == 'continue') {
        this.services.deleteItem(0, 0, this.tokenShop).subscribe(data => {
          if (data.hasError == false) {
            this.screenEnabled = true;
            this.router.navigate([path]);
          }
          else {
            this.notif(data.errorDesc);
          }
        });
      }
    });
  }
  verifyPaymentStatus(typeMessage, data, cont, session = '') {
    let cancel;
    //se evalua si se cancelo la carga en el loading
    this.loadingPayment = this.loadingScreenService.loadingStatus.subscribe((value: boolean) => {
      if (value == false) {
        cancel = true;
        this.loadingPayment.unsubscribe;
        this.loadingPayment.remove;
      }
    });
    let time = setTimeout(() => {
      if (cancel == true) {//si se cancela la carga se quita el tiempo y no carga mas el servicio
        cancel = false;
        this.loadingPayment.unsubscribe();
        clearTimeout(time);
      }
      else {
        this.loadingScreenService.startLoading(true, "Por favor espere, estamos verificando su pago.", true, session);
        this.services.verifyPaymentStatus(data.paymentToken).subscribe(result => {
          if (result.errorNum == 0) {
            if (result.processEndState == true) {
              if (result.hasError == false) {
                this.loadingScreenService.stopLoading();
                this.initialize.next();
                this.paymentReceived.next(true);
                this.giftReceived.next(true);
                this.achDataReceived.next(result);
                this.rechargeReceived.next([result.authorizationNumber, result.provisioningReference]);
                if (this.prepaidDataForEvaluate.token.length > 0) {
                  this.getEvaluatePlanPrepaid(true);
                }
              } else {
                this.loadingScreenService.stopLoading();
                this.notif(result.errorDisplay);
              }
            } else {
              if (cont < 2) {
                cont++;
                this.verifyPaymentStatus(typeMessage, data, cont, session);
              } else {
                if (typeMessage == 'payment') {
                  this.notif("Estimado cliente, hemos encontrado un problema al aplicar el pago en tu cuenta.   Si su pago fue autorizado por el banco, puede tomar entre 24 y 48 horas.   Si tiene alguna duda con su pago favor de consultarle a Centro de Servicio al cliente.");
                } else if (typeMessage == 'prepaid') {
                  // this.notif("Estimado cliente, hemos encontrado un problema verificar su pago.   Si su recarga fue autorizado por el banco, y no la ve reflejada no esta reflejada en su cuenta de Claro Prepago, favor de consultarle a Centro de Servicio al cliente.");
                  this.paymentReceived.next(false);
                } else {
                  this.notif("Estimado cliente, hemos encontrado un problema verificar su pago.   Si su compra fue autorizada por el banco, y no la ve reflejada no esta reflejada en su cuenta, favor de consultarle a Centro de Servicio al cliente.");
                }
                this.achDataReceived.next({showError: true});
                this.loadingScreenService.stopLoading();
              }
            }
          }
          else {
            this.loadingScreenService.stopLoading();
            this.notif(result.errorDisplay);
          }

        });
      }
    }, 30000);//60000
  }

  getEvaluatePlanPrepaid(isRechargin = false) {
    this.loadingScreenService.startLoading(true, "Por favor espere, estamos verificando la información.");
    this.services.getEvaluatePlanPrepaid(this.prepaidDataForEvaluate.token, this.prepaidDataForEvaluate.subscriber, this.prepaidDataForEvaluate.socId).subscribe(
      (resp: any) => {
        this.prepaidDataForEvaluate = {
          token: '',
          subscriber: '',
          socId: 0
        };
        this.loadingScreenService.stopLoading();
        if (!resp.hasError) {
          // todo
        } else {
          if (isRechargin) {
            const paymentToken = sessionStorage.getItem('paymentToken');
            this.notif(`Actualmente el sistema está presentando problemas de comunicación, por favor contacte a Soporte Operacional o intente nuevamente en los próximos minutos.`);
            this.voidPayment(paymentToken)
          }
        }
      },
      error => {
        this.loadingScreenService.stopLoading();
        this.notif("Actualmente el sistema está presentando problemas de comunicación, por favor contacte a soporte Operacional o intente nuevamente en los proximos minutos ");
      }
    );
  }

  typeAccount() {
    let type = sessionStorage.getItem("tab");
    let postpaidAccounts: any = this.fiterAccountBy(JSON.parse(atob(sessionStorage.getItem("AccountList"))), 'postpago');
    let prepaidAccounts: any = this.fiterAccountBy(JSON.parse(atob(sessionStorage.getItem("AccountList"))), 'prepago');
    let fixedAccounts: any = this.fiterAccountBy(JSON.parse(atob(sessionStorage.getItem("AccountList"))), 'telefoniaFijo');
    let currentAccountType;
    if (postpaidAccounts != '' && (type == 'postpago') || type == null) {
      currentAccountType = 'postpaid';
    }
    else if (prepaidAccounts != '' && (type == 'prepago') || type == null) {
      currentAccountType = 'prepaid';
    }
    else if (fixedAccounts != '' && (type == 'telefoniaFijo') || type == null) {
      currentAccountType = 'fixed';
    }
    return currentAccountType;
  }
  refreshDataTo(token) {
    let type = sessionStorage.getItem("tab");
    let account = sessionStorage.getItem("selectBan");
    let subscriber = this.getSuscriberByDefault(atob(account));
    this.loadingScreenService.startLoading(true, "Estamos actualizando su información.");
    this.services.accountDetails(token, btoa(subscriber), account).subscribe(data2 => {
      if (data2.HasError == false) {
        if (data2.AccounInfo.billBalanceField != null) {
          data2.AccounInfo.billBalanceField = data2.AccounInfo.billBalanceField.replace(',', '');
        }
        sessionStorage.setItem("getAccountDetails", btoa(JSON.stringify(data2)));
        this.updateBotChat(atob(account));
        if (type == 'prepago') {
          /*
          this.services.updateToken(token, account, subscriber).subscribe(data => {
            this.loadingScreenService.stopLoading();
            if (data.hasError == false) {
              sessionStorage.setItem("idCustomerCard", btoa(JSON.stringify(data.response)));
              localStorage.setItem("idCustomerCardExt", btoa(JSON.stringify(data.response)));
              this.loadObserver.next(0);
            }
            else {
              this.loadObserver.next(0);
            }
          });
          */
          this.loadObserver.next(0);
        }
        else {
          let statusField;
          for (let i = 0; i < data2.SubscriberInfo.length; i++) {
            if (data2.SubscriberInfo[i].subscriberNumberField == subscriber) {
              statusField = data2.SubscriberInfo[i].subscriberStatusField;
            }
          }
          this.suspendedAccount(statusField, atob(account), btoa(subscriber), data2.AccounInfo.billBalanceField);
          this.loadingScreenService.stopLoading();
          this.loadObserver.next(0);
        }

        if (this.router.url === '/flash-payment') {
          this.router.navigate(['home']).then();
        }
      }
      else {
        this.loadingScreenService.stopLoading();
        this.notif(data2.errorDisplay);
      }
    });
  }
  updateBotChat(account){
    let accountInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
    let typeOfAccount = this.checkTypeAccount(accountInfo["accountTypeField"], accountInfo["accountSubtypeField"]);
    if (typeOfAccount == 'postpago') {
      this.code = "501";
      this.region = "Region 1";
    }
    else if (typeOfAccount == 'prepago') {
      this.code = "552";
      this.region = "Region 1";
    }
    else if (typeOfAccount == 'telefoniaFijo') {
      this.code = "553";
      this.region = "Region 1";
    }
    else {
      this.code = "599";
      this.region = "Region 1";
    }
    this.services.botchat(sessionStorage.getItem("token"),sessionStorage.getItem("SSOAccessToken"), this.region, this.code, "e2f7386f-32d3-44ed-8088-0133d1191124", this.origin, accountInfo["firstNameField"] + " " + accountInfo["lastNameField"], account, accountInfo["emailField"], "Web", "").subscribe(data => {
      if (data.hasError == false) {
        this.urlChat = data.url;
        sessionStorage.setItem("botChat",this.urlChat);
      }
    });
  }
  getCreditsByAccount(token, selectBan, amountPay, type) {
    let credit;
    let totalCredit;
    let totalCreditoReal;
    let totalReferrs = 0;
    let totalRedeem = 0;
    this.services.getReferrals(token, selectBan).subscribe(data => {
      if (data.hasError == false) {
        if (data.CreditAsReferer !== null && data.CreditAsReferer !== undefined) {
          if (data.CreditAsReferer["discount"] > 0) {
            if (data.CreditItems !== null && data.CreditItems !== undefined) {
              if (data.CreditItems.length > 0) {
                if (data.CreditItems[0].TotalAvailable > 0) {
                  credit = data.CreditItems[0].TotalAvailable;
                  totalCredit = credit;
                  totalReferrs = data.CreditItems[0].CountReferrs;
                  totalRedeem = data.CreditItems[0].CountRedeems;
                }
                else {
                  credit = data.CreditAsReferer["discount"];
                  totalCredit = credit;
                }
              }
              else {
                credit = data.CreditAsReferer["discount"];
                totalCredit = credit;
              }
            }
            else {
              credit = data.CreditAsReferer["discount"];
              totalCredit = credit;
            }
          }
          else {
            if (data.CreditItems.length > 0) {
              credit = data.CreditItems[0].TotalAvailable;
              totalReferrs = data.CreditItems[0].CountReferrs;
              totalRedeem = data.CreditItems[0].CountRedeems;
              totalCredit = credit;
            }
            else {
              credit = 0;
              totalCredit = credit;
            }
          }
        }
        else {
          credit = data.CreditItems[0].TotalAvailable;
          totalReferrs = data.CreditItems[0].CountReferrs;
          totalRedeem = data.CreditItems[0].CountRedeems;
          totalCredit = credit;
        }
        totalCreditoReal = totalCredit;
        if (type == 'prepaid' && totalCredit > 25) {
          credit = 25;
        }
        else if (type == 'postpaid' && totalCredit > 50) {
          credit = 50;
        }
        else if (type == 'fixed' == true) {
          if (credit > 0) {
            if (credit > 50) {
              credit = 50;
              totalCredit = 50;
            }
            else {
              credit = ((parseFloat(totalCredit) * parseFloat(amountPay)) / 100).toFixed(2);
            }
          }
        }
        let data2 = {
          credit: credit,
          totalCredit: totalCredit,
          totalReferrs: totalReferrs,
          totalRedeem: totalRedeem
        };
        this.loadObserver2.next(data2);
      }
    });
  }
  subtractionDates(day, subtract) {
    let newdate = new Date(day);
    newdate.setDate(newdate.getDate() - subtract);
    return new Date(newdate);
  }
  newPayment(productId, typeMessage, currentBan, subscriber, amount, email, name, offerId, token, session = '', isP2P = false) {
    let crText;
    if ((amount).search('CR') > -1) {
      amount = parseFloat(amount);
      crText = "CR";
    }
    else {
      crText = "";
    }
    if (amount >= 5 && amount <= 2000) {
      this.loadingScreenService.startLoading();
      this.services.newPayment( productId, offerId).subscribe(data => {
        if (data.errorNum == 0) {
          if (data.paymentOptions.length > 0) {
            this.services.applyPayment(
              '',productId , data.paymentOptions[0].paymentOptionId,
              amount, email, subscriber, currentBan, name,
              JSON.parse(sessionStorage.getItem("accountInfo")).addressLinesField.line1Field? JSON.parse(sessionStorage.getItem("accountInfo")).addressLinesField.line1Field : "", JSON.parse(sessionStorage.getItem("accountInfo")).addressLinesField.line2Field,
              "san juan", "PR", "00956",
              "MICLAROWEB INVOICE PAYMENT", "", "", "", "", isP2P? 'ACHONLY' : '' ).subscribe(data2 => {
              if (data2.errorNum == 0 && data2.hasError == false) {
                sessionStorage.setItem('paymentToken', data2.paymentToken);
                this.urlPayment = data2.redirectURL;
                this.loadingScreenService.stopLoading();
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.minWidth = "300px";
                dialogConfig.data = { message: "Será redirigido al portal de pago para completar el mismo por la cantidad de $" + amount + crText + ".", colorSi: 'colorRed', colorNo: 'colorGray', btmConfirm: true, labelSi: 'Aceptar', labelNo: 'Cancelar' };
                const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(value => {
                  if (value == 'continue') {
                    //var windS= window.open(this.urlPayment, '_blank');
                    var windS = window.open(this.urlPayment, "Pago en línea", "width=1000,height=800,scrollbars=NO");
                    if (windS == null || typeof (windS) == 'undefined') {

                      const dialogConfig = new MatDialogConfig();
                      dialogConfig.disableClose = true;
                      dialogConfig.autoFocus = true;
                      dialogConfig.data = { message: "Estimado cliente, la ventana ha sido bloqueada por el navegador, para poder realizar el pago habilite la opcion de la ventana emergente en el navegador." };
                      const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
                      dialogRef.afterClosed().subscribe(value1 => {
                        if (value1 == 'continue') {
                          this.loadingScreenService.startLoading(true, "Estimado Cliente, estamos esperando que habilite los permisos de la ventana emergente, si ya realizó el pago por favor espere que lo validemos.", true, session);
                          this.verifyPaymentStatus(typeMessage, data2, 0, session);
                        }
                      });
                    }
                    else {
                      windS.focus();
                      this.loadingScreenService.startLoading(true, "Está siendo redirigido a la página del Banco Popular para realizar el pago.", true, session);
                      this.verifyPaymentStatus(typeMessage, data2, 0, session);
                    }
                  }
                });
              }
              else {
                this.loadingScreenService.stopLoading();
                // let username2 = sessionStorage.getItem("name");
                let menssageError = 'El servicio del banco no responde con la url de pago.';
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', email: email, btmConfirm: true };
                const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(value => {
                  if (value == 'continue') {
                    this.irChat();
                  }
                });
              }
            }, err => {
              console.log('error en newPayment =>',err)
            });
          }
          else {
            this.loadingScreenService.stopLoading();
            // let username2 = sessionStorage.getItem("name");
            let menssageError = 'El servicio del banco no responde con la url de pago.';
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', email: email, btmConfirm: true };
            const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(value => {
              if (value == 'continue') {
                this.irChat();
              }
            });
          }
        }
        else {
          this.loadingScreenService.stopLoading();
          let menssageError = 'El servicio del banco no responde con la url de pago.';
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.autoFocus = true;
          dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', email: email, btmConfirm: true };
          const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(value => {
            if (value == 'continue') {
              this.irChat();
            }
          });
        }
      });
    }
    else {
      if (amount < 5) {
        // this.notif("El monto no puede ser menor a $5.00.");
      }
      else if (amount > 2000) {
        // this.notif("El monto no puede ser mayor a $2000.00.");
      }
    }
  }

  newPaymentNoLimit(productId, typeMessage, currentBan, subscriber, amount, email, name, offerId, token, banSend = '', subscribeSend = '', locationId = '', invoiceNumber = '', session = '') {
    this.loadingScreenService.startLoading(true, "Está siendo redirigido a la página del Banco Popular para realizar el pago.", true);
    this.services.newPayment(productId, offerId).subscribe(data => {
      if (data.errorNum == 0) {
        if (data.paymentOptions.length > 0) {
          this.services.applyPayment(offerId, productId, data.paymentOptions[0].paymentOptionId, amount, email, subscriber, currentBan, name, "dir1", "dir2", "san juan", "PR", "00956", "MICLAROWEB INVOICE PAYMENT", banSend, subscribeSend, locationId, invoiceNumber, '').subscribe(data2 => {
            if (data2.errorNum == 0 && data2.hasError == false) {
              this.urlPayment = data2.redirectURL;
              this.loadingScreenService.stopLoading();
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              dialogConfig.autoFocus = true;
              dialogConfig.minWidth = "300px";
              dialogConfig.data = { message: "Será redirigido al portal de pago para completar el mismo por la cantidad de $" + amount + ".", colorSi: 'colorRed', colorNo: 'colorGray', btmConfirm: true, labelSi: 'Aceptar', labelNo: 'Cancelar' };
              const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
              dialogRef.afterClosed().subscribe(value => {
                if (value == 'continue') {
                  //var windS= window.open(this.urlPayment, '_blank');
                  var windS = window.open(this.urlPayment, "Pago en línea", "width=1000,height=800,scrollbars=NO");
                  if (windS == null || typeof (windS) == 'undefined') {

                    const dialogConfig = new MatDialogConfig();
                    dialogConfig.disableClose = true;
                    dialogConfig.autoFocus = true;
                    dialogConfig.data = { message: "Estimado cliente, la ventana ha sido bloqueada por el navegador, para poder realizar el pago habilite la opcion de la ventana emergente en el navegador." };
                    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
                    dialogRef.afterClosed().subscribe(value1 => {
                      if (value1 == 'continue') {
                        this.loadingScreenService.startLoading(true, "Estimado Cliente, estamos esperando que habilite los permisos de la ventana emergente, si ya realizó el pago por favor espere que lo validemos.", true, session);
                        this.verifyPaymentStatus(typeMessage, data2, 0, session);
                      }
                    });
                  }
                  else {
                    windS.focus();
                    this.loadingScreenService.startLoading(true, "Está siendo redirigido a la página del Banco Popular para realizar el pago.", true, session);
                    this.verifyPaymentStatus(typeMessage, data2, 0, session);
                  }
                }
              });

              // window.open(data2.redirectURL, '_blank');
              // this.verifyPaymentStatus(typeMessage,data2, 0);
            }
            else {
              this.loadingScreenService.stopLoading();
              let menssageError = 'El servicio del banco no responde con la url de pago.';
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              dialogConfig.autoFocus = true;
              dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', email: email, btmConfirm: true };
              const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
              dialogRef.afterClosed().subscribe(value => {
                if (value == 'continue') {
                  //colocar aqui el nuevo chat
                  this.irChat();
                  /*
                  let url = this.pathChat + '?Email=' + email + '&firstname=' + accountName[0] + '&lastname=' + accountName[1] + '&Question=' + 'Problema para iniciar el boton de pago.' + '&Department=' + '16' + '';
                  window.open(url, '', 'width=630, height=490,top=100,left=100');*/
                }
              });
            }
          });
        }
        else {
          this.loadingScreenService.stopLoading();
          let menssageError = 'El servicio del banco no responde con la url de pago.';
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.autoFocus = true;
          dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', email: email, btmConfirm: true };
          const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(value => {
            if (value == 'continue') {
              //colocar aqui el nuevo chat
              this.irChat();
              /*
              let url = this.pathChat + '?Email=' + email + '&firstname=' + accountName[0] + '&lastname=' + accountName[1] + '&Question=' + 'Problema para iniciar el boton de pago.' + '&Department=' + '16' + '';
              window.open(url, '', 'width=630, height=490,top=100,left=100');*/
            }
          });
        }
      }
      else {
        this.loadingScreenService.stopLoading();
        let menssageError = 'El servicio del banco no responde con la url de pago.';
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', email: email, btmConfirm: true };
        const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(value => {
          if (value == 'continue') {
            //colocar aqui el nuevo chat
            this.irChat();
            /*let url = this.pathChat + '?Email=' + email + '&firstname=' + accountName[0] + '&lastname=' + accountName[1] + '&Question=' + 'Problema para iniciar el boton de pago.' + '&Department=' + '16' + '';
            window.open(url, '', 'width=630, height=490,top=100,left=100');*/
          }
        });
      }
    });
  }

  doPayment(currentBan, mount, token) {
    if (mount >= 5 && mount <= 2000) {
      this.loadingScreenService.startLoading();
      this.services.doPayment(currentBan, mount, token).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if (data.response !== null) {
          // window.open(data.response, '_blank');
        }
        else {
          let email = atob(sessionStorage.getItem("email"));
          let menssageError = 'El servicio del banco no responde con la url de pago.';
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.autoFocus = true;
          dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', email: email, btmConfirm: true };
          const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(value => {
            if (value == 'continue') {
              this.irChat();
              /* let url = this.pathChat + '?Email=' + email + '&firstname=' + accountName[0] + '&lastname=' + accountName[1] + '&Question=' + 'Problema para iniciar el boton de pago.' + '&Department=' + '16' + '';
               window.open(url, '', 'width=630, height=490,top=100,left=100');*/
            }
          });
        }
      });
    }
    else {
      if (mount < 5) {
        this.notif("La cantidad a pagar debe ser mayor a $5.00 o menor de $2000.00");
      }
      else if (mount > 2000) {
        this.notif("La cantidad a pagar debe ser mayor a $5.00 o menor de $2000.00");
      }
    }
  }

  notif(msg) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: msg };
    return this.dialog.open(AlertasComponent, dialogConfig);
  }

  notifSignOff(msg) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: msg, session: true };
    this.dialog.open(AlertasComponent, dialogConfig);
  }

  session() {
    sessionStorage.setItem("session", "true");
    this.sessionCounter = 1;
    setTimeout(() => {
      if (this.checker == false) {
        this.checker = true;
        this.activeSession(0, false);
      }
    }, this.timeout);
  }

  activeSession(sw, close) {
    if (close == false) {
      if (sw == 0) {
        if (this.sessionCounter == this.minutes) {
          if (sessionStorage.getItem("session") == "true") {
            this.notifSignOff('Su sesión se ha vencido.');
            this.messageService.sentMessage("canceled", {
              method: "Su sesión se ha vencido.",
            });
            this.signOff();
          }
        }
        else {
          if (sessionStorage.getItem("session") == "true") {
            this.sessionCounter++;
            setTimeout(() => {
              this.activeSession(0, false);
            }, this.timeout);
          }
        }
      }
      else {
        this.sessionCounter = 1;
        this.notifSignOff('Su sesión se ha vencido.');
        this.notifSignOff('Su sesión se ha vencido.');
        this.messageService.sentMessage("canceled", {
          method: "Su sesión se ha vencido.",
        });
        this.signOff();
      }
    }
    else {
      this.sessionCounter = 1;
      sessionStorage.setItem("session", "false");
    }
  }

  validateSession() {
    let path = window.location.pathname;
    if (localStorage.getItem("tokenExternal") != null && sessionStorage.getItem("session") != "true" && (path != "/" && !window.location.pathname.startsWith("/login"))) {
      if (!this.loadingScreenService.loading) {
        this.loginExternal(localStorage.getItem("tokenExternal"));
      }
    }
    else {
      if (sessionStorage.getItem("session") == "false" || sessionStorage.getItem("session") == null) {
        if (window.location.pathname != null && window.location.pathname != "/"  && !window.location.pathname.startsWith("/login") ) {
          sessionStorage.setItem("externalLoginPath", window.location.pathname);
          sessionStorage.setItem("externalLoginSearch", window.location.search);
        }
        if (window.location.pathname != "/politics/1" && window.location.pathname != "/politics/2" && window.location.pathname != "/politics/3"  && window.location.pathname.substring(0, 17) !== "/recover-password" && window.location.pathname.substring(0, 6) !== "/login" && window.location.pathname !="/changeplan") {
          this.router.navigate(['login']);
        }
        return false;
      }
      else {
        this.session();
        return true;
      }
    }
  }

  validateInputKey(key) {
    let exprValid = /([\-.,_\*@A-Z0-9áéíóú\s\\]+)/i;
    if (!exprValid.test(key.key)) {
      return false;
    }
    let exprInvalid = /(\-\-|[\!'\(\)\[\]\;\"]+)/g;
    key.target.value = key.target.value.replace(exprInvalid, "");

  }

  sessionReview() {
    let path = window.location.pathname;
    if (localStorage.getItem("tokenExternal") != null && sessionStorage.getItem("session") != "true" && (path != "/" && path != "/login")) {
      if (!this.loadingScreenService.loading) {
        this.loginExternal(localStorage.getItem("tokenExternal"));
      }
    }
    else {
      if (sessionStorage.getItem("session") == "false" || sessionStorage.getItem("session") == null || sessionStorage.getItem("session") == undefined) {
        return false;
      }
      else {
        return true;
      }
    }
  }
  loginExternal(token) {
    let idUser: number;
    let objAccounts;
    let userName2: string;
    this.loadingScreenService.startLoading();
    this.services.loginExternal(token).subscribe(data => {
      if (data.hasError == false) {
        objAccounts = data.accounts;
        idUser = objAccounts.AccountList[0].userID;
        sessionStorage.setItem("token", data.token);
        var requiredEmailUpdate = data.requiredEmailUpdate;
        var requiredAccountUpdate = data.requiredAccountUpdate;
        sessionStorage.setItem("email", btoa(data.email));
        sessionStorage.setItem("selectBan", btoa(data.account));
        sessionStorage.setItem("logState", btoa(JSON.stringify(false))); // revisar
        sessionStorage.setItem("SSOAccessToken", data.SSOAccessToken);
        let accountName;
        let lastName: string = '';
        let name: string = '';
        if (data.name != "") {
          accountName = data.name.split(" ");
          name = accountName[0] + ' ' + accountName[1];
          for (let i = 0; i < accountName.length; i++) {
            if (i > 1) {
              lastName = lastName + ' ' + accountName[i];
            }
          }
          lastName = lastName.trim();
        }

        if (data.requiredPasswordReset == true) {
          this.requiredPasswordReset = true;
          this.loadingScreenService.stopLoading();
          this.router.navigate(['forgotpassword']);
        }
        else {
          sessionStorage.setItem("userName", data.username);
          if (data.name.length > 20) {
            userName2 = data.name.toString().substring(0, 20) + "...";
            sessionStorage.setItem("name", userName2);
          }
          else {
            sessionStorage.setItem("name", data.name);
          }
          if (accountName[0] == "MR." || accountName[0] == "MRS." || accountName[0] == "MS." || accountName[0] == "SR." || accountName[0] == "SRA.") {
            sessionStorage.setItem("firstName", accountName[1]);
          }
          else {
            sessionStorage.setItem("firstName", accountName[0]);
          }
          sessionStorage.setItem("userName2", btoa(data.username));
          sessionStorage.setItem("defaultSubscriber", btoa(data.subscriber)); //revisar si se esta guardando
          sessionStorage.setItem("requiredAccountUpdate", btoa(JSON.stringify(data.requiredAccountUpdate)));
          sessionStorage.setItem("firstload", btoa(JSON.stringify(false)));//revisar
          this.services.permissions(data.token, data.accountType, name, lastName).subscribe(dataPermission => {
            if (dataPermission.hasError == false) {
              sessionStorage.setItem("permissions", btoa(JSON.stringify(dataPermission)));
              sessionStorage.setItem("moduleData", btoa(JSON.stringify(dataPermission.permission)));
              this.services.accountDetails(data.token, btoa(data.subscriber), btoa(data.account)).subscribe(data2 => {
                if (data2.HasError == false) {
                  sessionStorage.setItem("getAccount", btoa(JSON.stringify(objAccounts)));
                  sessionStorage.setItem("AccountList", btoa(JSON.stringify(objAccounts.AccountList)));
                  if (data2.AccounInfo.billBalanceField != null) {
                    data2.AccounInfo.billBalanceField = data2.AccounInfo.billBalanceField.replace(',', '');
                  }
                  sessionStorage.setItem("getAccountDetails", btoa(JSON.stringify(data2)));
                  this.session();

                  if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo.length > 0) {
                    if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].prepaidBalanceField !== null) {
                      let prepaidBalance = JSON.stringify(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].prepaidBalanceField.toString());
                      prepaidBalance = prepaidBalance.replace(/"/g, '');
                      if (prepaidBalance.search('CR') > -1) {
                        sessionStorage.setItem("prepaidBalance", btoa('0'));
                      }
                      else {
                        sessionStorage.setItem("prepaidBalance", btoa(prepaidBalance));
                      }
                    }
                    sessionStorage.setItem("socRateField", btoa(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].planInfoField.socRateField));
                  }
                  sessionStorage.setItem("popPreguntasSeguridad", btoa(JSON.stringify(data.requiredQuestions)));
                  if (requiredEmailUpdate === true) {
                    this.router.navigate(['profile/2']);
                  }
                  else if (requiredAccountUpdate === true) {
                    this.router.navigate(['profile/3']);
                  }
                  else {
                    this.suspendedAccount(data2.SubscriberInfo[0].subscriberStatusField, data.account, btoa(data.subscriber), data2.AccounInfo.billBalanceField);
                    this.loadingScreenService.stopLoading();
                    window.location.reload(); // ajustar
                  }
                }
                else {
                  this.loadingScreenService.stopLoading();
                  this.notif(data2.errorDisplay);
                }
              });
            }
            else {
              this.loadingScreenService.stopLoading();
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              dialogConfig.autoFocus = true;
              dialogConfig.data = { inverse: true, messageHtml: true, message: dataPermission.errorDesc };
              const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
              dialogRef.afterClosed().subscribe(value => {
              });
            }
          });
        }
      }
    });
  }
  public signOff() {
    this.checker = false;
    this.sessionCounter = 1;
    sessionStorage.setItem("session", "false");
    sessionStorage.setItem("objLogin", null);
    sessionStorage.setItem("menu", null);
    sessionStorage.setItem("suscriptorCreado", null);
    sessionStorage.setItem("session", null);
    sessionStorage.setItem("selectBan", null);
    sessionStorage.setItem("getAccountDetails", null);
    sessionStorage.setItem("getHistoricoFacturas", null);
    sessionStorage.setItem("GetPersonalData", null);
    sessionStorage.setItem("updatePersonalData", null);
    sessionStorage.setItem("userName", null);
    sessionStorage.setItem("userName2", null);
    sessionStorage.setItem("defaultSubscriber", null);
    sessionStorage.setItem("requiredAccountUpdate", null);
    sessionStorage.setItem("getAcoout", null);
    sessionStorage.setItem("token", null);
    sessionStorage.setItem("menu", null);
    sessionStorage.setItem("getPaymentHistory", null);
    sessionStorage.setItem("getquestions", null);
    sessionStorage.setItem("getChallengeQuestions2", null);
    sessionStorage.setItem("popPreguntasSeguridad", null);
    sessionStorage.setItem("banlist", null);
    sessionStorage.setItem("actualPdf", null);
    sessionStorage.setItem("tab", null);
    sessionStorage.setItem("name", null);
    sessionStorage.setItem("firstload", null);
    sessionStorage.setItem("permissions", null);
    sessionStorage.setItem("moduleData", null);
    sessionStorage.setItem("AccountList", null);
    sessionStorage.setItem("SSOAccessToken", null);
    sessionStorage.setItem("currentBan", null);
    sessionStorage.setItem("socRateField", null);
    sessionStorage.setItem("getAccount", null);
    sessionStorage.setItem("logState", null);
    sessionStorage.setItem("email", null);
    sessionStorage.setItem("currentFixed", null);
    sessionStorage.setItem("currentSuscriber", null);
    sessionStorage.setItem("referredtSubscriber", null);
    sessionStorage.setItem("botChat", null);
    sessionStorage.setItem("memberID", null);
    localStorage.setItem("tokenExternal", null);
    localStorage.setItem("idCustomerCardExt", null);
    localStorage.setItem("idCustomerCard", null);
    sessionStorage.setItem("selectedLine", null);
    sessionStorage.setItem("currentPrepaid", null);
    sessionStorage.setItem("firstName", null);
    sessionStorage.setItem("prepaidBalance", null);
    sessionStorage.setItem("idCustomerCard", null);
    sessionStorage.setItem("activeNavigation", null);
    sessionStorage.setItem("idPlan", null);
    sessionStorage.setItem("PlanSelectionScreen", null);
    sessionStorage.setItem("dataPlanSelect", null);
    sessionStorage.setItem("accountInfo", null);
    sessionStorage.setItem("subscriberInfo", null);
    sessionStorage.setItem("email",null);
    sessionStorage.setItem("makeChange",null);
    sessionStorage.setItem("tokenShop",null);
    sessionStorage.setItem("currentPostpaid",null);
    sessionStorage.setItem("banExisting", null);
    sessionStorage.setItem("buyBlock", null);
    sessionStorage.setItem("BillDateDonwload", null);
    sessionStorage.setItem("idUserAPP", null);
    sessionStorage.setItem("idParent", null);
    sessionStorage.setItem("totalBalance", null);
    sessionStorage.setItem("companyName", null);
    sessionStorage.setItem("idUser", null);
    sessionStorage.setItem("listData", null);
    sessionStorage.setItem("invoiceContentDonwload", null);

    sessionStorage.removeItem("subscriberExisting");
    sessionStorage.removeItem("splashActive");
    sessionStorage.removeItem("invoiceContentDonwload");
    sessionStorage.removeItem("listData");
    sessionStorage.removeItem("idUser");
    sessionStorage.removeItem("companyName");
    sessionStorage.removeItem("totalBalance");
    sessionStorage.removeItem("idParent");
    sessionStorage.removeItem("idUserAPP");
    sessionStorage.removeItem("BillDateDonwload");
    sessionStorage.removeItem("buyBlock");
    sessionStorage.removeItem("banExisting");
    sessionStorage.removeItem("currentPostpaid");
    sessionStorage.removeItem("tokenShop");
    sessionStorage.removeItem("makeChange");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("subscriberInfo");
    sessionStorage.removeItem("accountInfo");
    sessionStorage.removeItem("dataPlanSelect");
    sessionStorage.removeItem("idPlan");
    sessionStorage.removeItem("PlanSelectionScreen");
    sessionStorage.removeItem("activeNavigation");
    sessionStorage.removeItem("idCustomerCard");
    sessionStorage.removeItem("prepaidBalance");
    sessionStorage.removeItem("firstName");
    sessionStorage.removeItem("currentPrepaid");
    sessionStorage.removeItem("selectedLine");
    localStorage.removeItem("idCustomerCard");
    localStorage.removeItem("idCustomerCardExt");
    localStorage.removeItem("tokenExternal");
    sessionStorage.removeItem("memberID");
    sessionStorage.removeItem("botChat");
    sessionStorage.removeItem("referredtSubscriber");
    sessionStorage.removeItem("currentSuscriber");
    sessionStorage.removeItem("currentFixed");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("logState");
    sessionStorage.removeItem("getAccount");
    sessionStorage.removeItem("socRateField");
    sessionStorage.removeItem("currentBan");
    sessionStorage.removeItem("SSOAccessToken");
    sessionStorage.removeItem("AccountList");
    sessionStorage.removeItem("moduleData");
    sessionStorage.removeItem("permissions");
    sessionStorage.removeItem("firstload");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("tab");
    sessionStorage.removeItem("actualPdf");
    sessionStorage.removeItem("banlist");
    sessionStorage.removeItem("objLogin");
    sessionStorage.removeItem("menu");
    sessionStorage.removeItem("suscriptorCreado");
    sessionStorage.removeItem("session");
    sessionStorage.removeItem("selectBan");
    sessionStorage.removeItem("getAccountDetails");
    sessionStorage.removeItem("getHistoricoFacturas");
    sessionStorage.removeItem("GetPersonalData");
    sessionStorage.removeItem("updatePersonalData");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("userName2");
    sessionStorage.removeItem("defaultSubscriber");
    sessionStorage.removeItem("requiredAccountUpdate");
    sessionStorage.removeItem("getAcoout");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("menu");
    sessionStorage.removeItem("getPaymentHistory");
    sessionStorage.removeItem("getquestions");
    sessionStorage.removeItem("getChallengeQuestions2");
    sessionStorage.removeItem("popPreguntasSeguridad");
    sessionStorage.clear();
    this.router.navigate(['login']);
  }

  cleanExternalLoginPath() {
    sessionStorage.setItem("externalLoginPath", null);
    sessionStorage.setItem("externalLoginSearch", null);
    sessionStorage.removeItem("externalLoginPath");
    sessionStorage.removeItem("externalLoginSearch");
  }

  validarEmail(email) {
    let expr = /^(?=[A-Z])[A-Z0-9_\-\.]+@(?=(([A-Z0-9_\-]+\.)+))\1[A-Z]{2,4}$/i;
    if (!expr.test(email)) {
      return false;
    } else {
      return true;
    }
    //return !expr.test(email);
  }
  check(value) {
    if (value == 'G') {
      this.mixed = true;
    }
  }
  accountsThatApply(accountType, accountSubtype, productType, idPlan) {
    let ifApply = false;
    if (accountType == 'I' && accountSubtype == 'S' && productType == 'G') {
      ifApply = true;
    }
    else if (accountType == 'I' && accountSubtype == 'S' && productType == 'O') {
      ifApply = true;
    }
    else if (accountType == 'I' && accountSubtype == 'S' && productType == 'V') {
      ifApply = true;
    }
    else if (accountType == 'I' && accountSubtype == 'P' && productType == 'G') {
      ifApply = true;
    }

    else if (accountType == 'I' && accountSubtype == 'W' && productType == 'O') {
      if (this.plansThatDontApply(idPlan) == true) {
        ifApply = true;
      }
    }
    else if (accountType == 'I' && accountSubtype == 'W' && productType == 'V') {
      if (this.plansThatDontApply(idPlan) == true) {
        ifApply = true;
      }
    }
    else if (accountType == 'I2' && accountSubtype == '4' && productType == 'G') {
      ifApply = true;
    }
    else if (accountType == 'I3' && accountSubtype == '4' && productType == 'G') {
      ifApply = true;
    }
    else if (accountType == 'I3' && accountSubtype == 'P' && productType == 'G') {
      ifApply = true;
    }
    else if (accountType == 'I' && accountSubtype == 'W' && productType == 'G') {
      // ifApply = true;
      if (this.plansThatDontApply(idPlan) == true) {
        ifApply = true;
      }
    }
    return ifApply;
  }
  plansThatDontApply(idPlan) {
    let ifApply = true;
    if (idPlan == '3448' || idPlan == '8378' || idPlan == '11114' || idPlan == '34480' || idPlan == '43342' || idPlan == '11111' || idPlan == '11113' || idPlan == '11112' || idPlan == '3347' || idPlan == '66801' || idPlan == '8388' || idPlan == '8371' || idPlan == '8383' || idPlan == '4982' || idPlan == '43340' || idPlan == '34481' || idPlan == '4983' || idPlan == '66800' || idPlan == '66802' || idPlan == '11091' || idPlan == '11092' || idPlan == '43341' || idPlan == '11361' || idPlan == 'IPBASI2' || idPlan == 'IPBAP2' || idPlan == 'IPSIG2' || idPlan == 'IPESE2') {
      ifApply = false;
    }
    return ifApply;
  }
  validateIfApplicable(accounInfo, info, redeemProgram) {
    let ifApply = false;
    this.referredData = [];
    for (let i = 0; i < info.length; i++) {
      if (this.accountsThatApply(accounInfo.accountTypeField, accounInfo.accountSubtypeField, info[i].productTypeField, info[i].planInfoField.sOCInfoField) == true) {
        if (redeemProgram == true && info[i].subscriberStatusField == 'A') {
          ifApply = true;
          this.referredData.push(info[i]);
        }
      }
    }
    if (ifApply == false) {
      this.notif("¡Gracias por su interés en nuestro Programa Refiere y Gana! Su cuenta no cumple con los requisitos de participación del Programa.  Para información adicional comuníquese con unos de nuestros Coordinadores de Servicio al Cliente a través de nuestro CHAT, o revise las reglas, términos y condiciones de esta promoción.");
      return false;
    }
    else {
      return true;
    }
  }
  usage_info() {
    let counter1 = 0;
    let iDLocal: number = 0;
    let counter2 = 0;
    let percentage: number = 0;
    let counterPad = 0;
    let usage = '{';
    usage += '"subscribers":';
    usage += '[';
    for (var i = 0; i < this.info.length; i++) {
      this.check(this.info[i].productTypeField);
      counter2 = 0;
      counterPad = 0;
      if (counter1 > 0) { usage += ','; }
      usage += '{';
      usage += '"subscriber":';
      usage += '[';
      this.info[i].usageInfoField.dataOffersField.map(function (offers) {
        if (counter2 > 0) { usage += ','; }
        usage += '{';
        usage += '"offerGroup":"' + offers.offerGroupField + '",';
        usage += '"DPlanName":"' + offers.displayNameField + '",';
        usage += '"Quota":"' + offers.quotaField + '",';
        usage += '"DLocalTop":"' + offers.quotaTextField + '",';
        usage += '"iDLocal":"' + offers.usedField + '",';
        usage += '"iDLocalText":"' + offers.usedTextField + '",';
        if (parseFloat(offers.quotaField) > 0) {
          if (offers.usedField === null) {
            iDLocal = 0;
          }
          else {
            iDLocal = offers.usedField;
          }
          percentage = (iDLocal * 100) / parseFloat(offers.quotaField);
          percentage = parseInt(percentage.toString());
        }
        usage += '"percentage":' + percentage + ',';
        if (offers.offerGroupField.search('BASE') > -1) {
          usage += '"type":"PL-ACT"';
        }
        else if (offers.offerGroupField.search("NT_ROAM_GRANEL") > -1) {
          usage += '"type":"DR"';
        }
        else {
          if (counterPad === 0) {
            usage += '"type":"PQ-AD"';
          }
          else {
            usage += '"type":""';
          }
          counterPad++;
        }
        usage += '}';
        counter2++;
      });
      usage += '],"countDR":' + counter2 + ',"countPQAD":' + counterPad + ',"productType":"' + this.info[i].productTypeField + '"';
      usage += '}';
      counter1++;
    }
    usage += ']';
    usage += '}';
    this.usage2 = JSON.parse(usage).subscribers;
  }

  loadCanvas() {
    let objHtml;
    for (let i = 0; i < this.usage2.length; i++) {
      for (let j = 0; j < this.usage2[i].subscriber.length; j++) {
        objHtml = 'idCanvasPaq_' + i + '_' + j;
        this.pid2D(document.getElementById(objHtml), this.usage2[i].subscriber[j].percentage);
      }
    }
  }

  pid2D(elCanvas, proc) {
    let X = 110;
    let Y = 110;
    let radio = 80;
    let borde = 50;
    let giro = 4.74;
    let separacion = 0.030;
    let total = 6.28;
    let circulo = Math.PI * 2;
    if (proc === 100) {
      if (elCanvas && elCanvas.getContext) {
        let context = elCanvas.getContext('2d');
        context.beginPath();
        context.strokeStyle = '#d9392d';
        context.lineWidth = borde;
        context.arc(X, Y, radio, giro, (total * 4), false);
        context.stroke();
        context.closePath();
      }
    }
    else if (proc === 0) {
      if (elCanvas && elCanvas.getContext) {
        let context = elCanvas.getContext('2d');
        context.beginPath();
        context.strokeStyle = '#eaeaea';
        context.lineWidth = borde;
        context.arc(X, Y, radio, giro, (total * 4), false);
        context.stroke();
        context.closePath();
      }
    }
    else {
      let resultG1 = (total * proc) / 100;
      let resultG2 = resultG1 - circulo;

      if (elCanvas && elCanvas.getContext) {
        let context = elCanvas.getContext('2d');
        context.beginPath();
        context.strokeStyle = '#d9392d';
        context.lineWidth = borde;
        context.arc(X, Y, radio, giro, ((resultG1 + giro) - separacion), false);
        context.stroke();
        context.closePath();

        context.beginPath();
        context.strokeStyle = '#eaeaea';
        context.lineWidth = borde;
        context.arc(X, Y, radio, (giro - separacion), ((resultG2 + giro)), true);
        context.stroke();
        context.closePath();
      }
    }
  }

  getSuscriberByDefault(accountId) {
    let accountList = JSON.parse(atob(sessionStorage.getItem("AccountList")));
    let subsriberByDefault = null;
    for (let i = 0; i < accountList.length; i++) {
      if (parseInt(accountList[i].account) === parseInt(accountId)) {
        subsriberByDefault = accountList[i].subsriberByDefault;
      }
    }
    return subsriberByDefault;
  }

  checkTypeAccount(tipo, SubTipo) {
    let typeAccount = 'no-detect';
    if ((tipo === 'F' && SubTipo === '4') || (tipo === 'I3' && SubTipo === '4') || (tipo === 'I' && SubTipo === 'S') || (tipo === 'I2' && SubTipo === '4') || (tipo === 'I' && SubTipo === 'R') || (tipo === 'I' && SubTipo === '4') || (tipo === 'I' && SubTipo === 'E')) {
      typeAccount = 'postpago';
    }
    if ((tipo === 'I' && SubTipo === 'P') || (tipo === 'I3' && SubTipo === 'P')) {
      typeAccount = 'prepago';
    }
    if (tipo === 'I' && SubTipo === 'W') {
      typeAccount = 'telefoniaFijo';
    }
    return typeAccount;
  }

  fiterAccountBy(accounts, tipo) {
    let cuentas_filtradas = Array();
    let checkTypeAccount = this.checkTypeAccount;
    accounts.map(function (ac) {
      if (checkTypeAccount(ac.accountType, ac.accountSubType) === tipo) {
        cuentas_filtradas.push(ac);
      }
    });
    return cuentas_filtradas;
  }

  mask(data) {
    if (!!data) {
      let start = ' ( ' + data.substring(0, 3) + ' ) ';
      let middle = data.substring(3, 6) + '-';
      let end = data.substring(6, 10);
      return start + middle + end;
    }
  }
  suspendedAccount(type, currentBan, defaultSubscriber, mount, session = '') {
    let typeMessage = 'payment';
    if (type == "S") {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data = { message: 'Su cuenta ' + currentBan + ' esta suspendida. Para activar la misma, favor realice su pago.', btmConfirm: true, labelSi: 'Pagar', labelNo: 'Cancelar' };
      const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(value => {
        if (value == 'continue') {
          this.newPayment(1, typeMessage, currentBan, atob(defaultSubscriber), mount, atob(sessionStorage.getItem("email")), sessionStorage.getItem("name"), "", sessionStorage.getItem("token"), session);
        }
        else {
          this.router.navigate(['home']);
        }
      });
    }
  }

  createAdaptiveJson(currentJson: any, myJson: any, numberItemsPage: number) {
    let newJson = [];
    let items = [];
    let npartitions: number = 0;
    let mod: boolean;
    if ((myJson.length % numberItemsPage) == 0) {
      npartitions = myJson.length / numberItemsPage;
      mod = false;
    }
    else {
      npartitions = Math.trunc(myJson.length / numberItemsPage) + 1;
      mod = true;
    }
    if (currentJson.length != npartitions) {
      for (let i = 0; i < myJson.length; i++) {
        items.push(myJson[i]);
        if ((i + 1) % numberItemsPage == 0) {
          newJson.push(items);
          items = [];
        }
        if (mod && (i + 1) == myJson.length) {
          newJson.push(items);
        }
      }
    }
    else {
      newJson = currentJson;
    }
    return newJson;
  }
  addToCart(parentCartId: any, parentProductId: any, deviceId: any, creditClass: any, decPrice: any, downPayment: any, regularPrice: any, quantityDef: any, installments: number, method: string = 'clear') {
    if (method == 'clear') {
      this.cartItems = [];
    }
    let ssoToken: any = '';
    let result = "";
    let items = '';
    let deposit: number = 0;
    let idFlowBackend: number = 1;
    items += '{';
    items += '"token":"' + this.tokenShop +
      '", "productId":' + deviceId +
      ', "promoCode":""' +
      ',"installments":' + installments +
      ',"decPrice":' + decPrice +
      ',"decDeposit":' + deposit +
      ',"decDownPayment":' + downPayment +
      ',"decTotalPrice":' + regularPrice +
      ',"Qty":' + quantityDef +
      ',"flowId":' + idFlowBackend +
      ',"ssoToken":"' + ssoToken + '"' +
      ',"userID":0' +
      ',"parentProductId":' + parentProductId +
      ',"parentCartId":' + parentCartId +
      ',"creditClass":"' + creditClass + '"' +
      ',"downgradeAllowed":false' +  //esta demas quitar del servicio
      ',"pendingAccelerated":0' +  //cuotas installment
      ',"acceletartedAmount":0' + //monto de installmenet
      ',"pastDueAmount":0' +  //moton de deuda
      ',"delicuency": false';   // revisar
    items += '}';
    this.cartItems.push(items);
    result = '[' + this.cartItems + ']';
    return result;
  }
  sendCart(items: any,addId:any) {
    const studentsObservable = new Observable(observer => {
      this.loadingScreenService.startLoading();
      this.services.addToCart(items, sessionStorage.getItem("token")).subscribe(data => {
        this.loadingScreenService.stopLoading();
        let hasError = data.hasError;
        if (hasError == true) {
          observer.next(null);
          this.notif(data.errorDesc);
        }
        else{
          sessionStorage.setItem("lastAdded",addId.toString());
        }
        observer.next(hasError);
      });
    });
    return studentsObservable;
  }

  getCart() {
    const studentsObservable = new Observable(observer => {
      this.services.getCart(this.tokenShop).subscribe((data: any) => {
        if (data.hasError == false) {
          observer.next(data);
        }
        else {
          this.loadingScreenService.stopLoading();
          this.notif(data.errorDesc);
          observer.next(null);
        }
      });
    });
    return studentsObservable;
  }
  searchItemsDelete(itemsCart: any, type: string, currentParentCartId: number) {
    const deleteObservable = new Observable(observer => {
      let countItems = [];
      for (let i = 0; i < itemsCart.products.length; i++) {
        if (type == 'plan') {
          if (itemsCart.products[i].plan == true && itemsCart.products[i].parentCartId == currentParentCartId) {
            countItems.push(itemsCart.products[i].cartId);
          }
        }
        if (itemsCart.products[i].sva == true && itemsCart.products[i].parentCartId == currentParentCartId || (itemsCart.products[i].iptv == true && i > 0)) {
          countItems.push(itemsCart.products[i].cartId);
        }
      }
      for (let i = 0; i < countItems.length; i++) {
        this.services.deleteItem(countItems[i], 0,this.tokenShop).subscribe((data: any) => {
          if (data.hasError == false) {
            if (i == (countItems.length - 1)) {
              observer.next(type);
            }
          }
          else {
            this.loadingScreenService.stopLoading();
            this.notif(data.errorDesc);
          }
        });
      }
      if (countItems.length == 0) {
        observer.next(type);
      }
    });
    return deleteObservable;
  }
  concatenateText(text: string, length: number) {
    let data = text.slice(0, length);
    if (text.length > length) {
      data = data + '...';
    }
    return data;
  }
  stringCalculation(txt: string, count: number, length: number) {
    let qty = (length / count);
    return this.concatenateText(txt, qty);
  }
  showTerms(type: string, title: string, message: string, btm: boolean = false, btmPrint:boolean=true) {
    const studentsObservable = new Observable(observer => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      if (type == 'template') {
        this.services.getTemplete(message).subscribe(templete => {
          dialogConfig.data = { messageHtml: true, labelTitle: title, contentHtml: templete, labelContinue: "Aceptar", labelCancel: "Cancelar", btm: btm, labelPrint: "Imprimir",btmPrint: btmPrint};
          const dialogRef2 = this.dialog.open(PopTermsComponent, dialogConfig);
          dialogRef2.afterClosed().subscribe(value => {
            observer.next(value);
          });
        });
      }
      else {
        dialogConfig.data = { messageHtml: true, labelTitle: title, contentHtml: message, labelContinue: "Aceptar", labelCancel: "Cancelar", btm: btm, labelPrint: "Imprimir" };
        const dialogRef2 = this.dialog.open(PopTermsComponent, dialogConfig);
        dialogRef2.afterClosed().subscribe(value => {
          observer.next(value);
        });
      }
    });
    return studentsObservable;
  }
  textShortener(input: string, clear: string, maximumLength: number, complement: string) {
    try{
      let result: string = '';
      result = input.replace(clear, "");
      if (result.length > maximumLength) {
        result = result.substring(0, maximumLength);
        result += complement;
      }
      return result;
    }
    catch{
      return "";
    }
  }
  openPDF(binary){
    var iframe = "<iframe width='100%' height='100%' src='" + "data:application/pdf;base64," + binary + "'></iframe>"
    var x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();
  }

  goToStore(ban:string) {
    const objResult = new Observable(observer => {
      this.services.goToStore(this.ssoToken,ban).subscribe((data:any) => {
        if (data.hasError == false) {
          if (data.token != "") {
            this.tokenShopUrl=data.token;
            sessionStorage.setItem("tokenShopUrl",data.token);
          }
          observer.next(data.token);
          observer.unsubscribe();
        }
        else{
          this.notif(data.errorDesc);
          observer.next(data.hasError);
          observer.unsubscribe();
        }
      },error => this.errorHandling(error));
    });
    return objResult;
  }

  goStore(){
    let url =
    this.domain + 'auth?token=&ssoToken='+ // Prod
    //'http://shopqa.com/auth?token=&ssoToken='+ // QA
   sessionStorage.getItem('SSOAccessToken');
  var windS = window.open(url, "_blank");
  if (windS == null || typeof windS == "undefined") {
    this.notif(
      "Estimado cliente, la ventana ha sido bloqueada por el navegador, para redirigirte a la tienda de Claro, habilite la opción en la ventana emergente en el navegador."
    );
  }
  }

}
